import axios from "axios";
import API from "../api";
import cloneDeep from "lodash.clonedeep";

export const ContactsModule = {
  state: {
    contacts: [
      {
        first_name: "",
        middle_name: "",
        last_name: "",
        photo_uri: "",
        photo_md_uri: "",
        photo_sm_uri: "",
        passport_number: "",
        birthday: "",
        country_of_origin: "",
        citizenship: "",
        sex: "",
        email: "",
        phone: "",
        address: "",
        facebook: "",
        instagram: "",
        twitter: "",
        snapchat: "",
        pinterest: "",
        company: "",
        title: ""
      }
    ],
    isFetchingContacts: false,
    isRequesting: false,
    errored: false,
    error: ""
  },

  actions: {
    getContacts({ commit }) {
      commit("getContactsRequest");
      axios
        .get(`${API.BASE_URL}${API.GUESTS}`, API.RequestHeaders())
        .then(response => {
          if (response.status === 200) {
            commit("getContactsSuccess", response.data);
          }
        })
        .catch(error => {
          commit("getContactsError", error.message);
        });
    },
    addContact({ commit }, formData) {
      commit("addContactRequest");
      const submitData = {
        first_name: formData.first_name,
        middle_name: formData.middle_name,
        last_name: formData.last_name,
        passport_number: formData.passport_number,
        birthday: formData.birthday,
        country_of_origin: formData.country_of_origin,
        citizenship: formData.citizenship,
        sex: formData.sex,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        facebook: formData.facebook,
        instagram: formData.instagram,
        twitter: formData.twitter,
        snapchat: formData.snapchat,
        pinterest: formData.pinterest,
        // company, title ??
        company: formData.company,
        title: formData.title,
        photo_uri: formData.photo_uri,
        photo_md_uri: formData.photo_md_uri,
        photo_sm_uri: formData.photo_sm_uri,
      };
      return new Promise((resolve, reject) => {
        return axios
          .post(`${API.BASE_URL}${API.GUESTS}`, submitData, API.RequestHeaders())
          .then(response => {
            if (response.status === 201) {
              const newGuest = response.data.original;
              commit("addContactSuccess", newGuest);
              resolve(newGuest);
            }
          })
          .catch(error => {
            commit("addContactError", error.message);
            reject(error.message);
          });
      });
    },
    updateContact({ commit }, formData) {
      commit("updateContactRequest");
      const submitData = {
        first_name: formData.first_name,
        middle_name: formData.middle_name,
        last_name: formData.last_name,
        passport_number: formData.passport_number,
        birthday: formData.birthday,
        country_of_origin: formData.country_of_origin,
        citizenship: formData.citizenship,
        sex: formData.sex,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        facebook: formData.facebook,
        instagram: formData.instagram,
        twitter: formData.twitter,
        snapchat: formData.snapchat,
        pinterest: formData.pinterest,
        company: formData.company,
        title: formData.title,
        photo_uri: formData.photo_uri,
        photo_md_uri: formData.photo_md_uri,
        photo_sm_uri: formData.photo_sm_uri,
      };
      axios
        .put(
          `${API.BASE_URL}${API.GUESTS}/${formData.id}`,
          submitData,
          API.RequestHeaders()
        )
        .then(response => {
          if (response.status === 200) {
            commit("updateContactSuccess", response.data.original);
          }
        })
        .catch(error => {
          commit("updateContactError", error.message);
        });
    },
    removeContact({ commit }, contactId) {
      return new Promise((resolve, reject) => {
        commit("removeContactRequest");

        axios
          .delete(`${API.BASE_URL}${API.GUESTS}/${contactId}`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("removeContactSuccess", contactId);
              resolve(response);
            }
          })
          .catch(error => {
            commit("removeContactError", error.message);
            reject(error.message);
          });
      });
    }
  },

  mutations: {
    getContactsRequest(state) {
      state.isFetchingContacts = true;
    },
    getContactsSuccess(state, payload) {
      state.isFetchingContacts = false;

      state.contacts = [...payload];
    },
    getContactsError(state, payload) {
      state.isFetchingContacts = false;
      state.errored = true;
      state.error = payload;
    },
    addContactRequest(state) {
      state.isRequesting = true;
    },
    addContactSuccess(state, payload) {
      state.isRequesting = false;

      state.contacts.push(payload);
    },
    addContactError(state, payload) {
      state.isRequesting = false;
      state.error = payload;
    },
    updateContactRequest(state) {
      state.isRequesting = true;
    },
    updateContactSuccess(state, payload) {
      state.isRequesting = false;

      let updatedContact = state.contacts.find(contact =>
        contact.id === payload.id
      );

      Object.assign(updatedContact, payload);
    },
    updateContactError(state, payload) {
      state.isRequesting = false;
      state.errored = true;
      state.error = payload;
    },
    removeContactRequest(state) {
      state.isRequesting = true;
    },
    removeContactSuccess(state, id) {
      state.isRequesting = false;
      // find the removed object
      const removedObject = state.contacts.find(
        contact => contact.id === id
      );
      // find the index of the remove object in contacts array
      const removedObjectIndex = state.contacts.indexOf(removedObject);

      // remove the object from state
      state.contacts.splice(removedObjectIndex, 1);
    },
    removeContactError(state, payload) {
      state.isRequesting = false;
      state.error = payload;
    }
  },

  getters: {
    getContact: (state, getters) => (id) => {
      return getters.getContacts.find(contact => contact.id === id);
    },
    getContacts(state) {
      return state.contacts;
    },
    getContactsCopy(state) {
      return cloneDeep(state.contacts);
    }
  }
};
